document.addEventListener('DOMContentLoaded', function () {
    const baseOptions = {
        type: 'loop',
        perMove: 1,
        arrows: true,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        pauseOnHover: false,
        pagination: true,
        accessibility: false,
        waitForTransition: false,
        flickMaxPages: 1,
        flickPower: 120,
        drag: true,
        snap: true,
        i18n: {
            prev: 'Diapositiva precedente',
            next: 'Diapositiva successiva',
            first: 'Vai alla prima diapositiva',
            last: 'Vai all’ultima diapositiva',
            slideX: 'Vai alla diapositiva %s',
            pageX: 'Vai alla pagina %s',
            play: 'Riprendi le diapositive',
            pause: 'Metti in pausa le diapositive',
            carousel: 'carosello',
            slide: 'diapositiva',
            select: 'Seleziona una diapositiva da mostrare',
            slideLabel: '%s di %s',
        },
    };

    document.querySelectorAll('.hero-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            autoplay: true,
            interval: 5000,
            perPage: 1,
            pauseOnHover: true,
            pauseOnFocus: true,
        });

        const toggle = el.querySelector('.splide__toggle');
        // Pointer activation must keep its intended action when focus pauses rotation.
        toggle?.addEventListener('pointerdown', (event) => event.preventDefault());
        el.addEventListener('focusin', (event) => {
            if (!el.contains(event.relatedTarget)) {
                splide.Components.Autoplay.pause();
            }
        });

        splide.mount();
        if (toggle && splide.length < 2) toggle.hidden = true;
        if (el.contains(document.activeElement)) splide.Components.Autoplay.pause();
    });

    // Keep eager mounting: existing card heights are finalized by Splide.
    // Let Splide size the clone pool from perPage at the active breakpoint.
    // Choose product splide
    document.querySelectorAll('.choose-products-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: true,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Related product splide
    document.querySelectorAll('.related-products-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: true,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Blog teaser splide
    document.querySelectorAll('.blog-teaser-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Category teaser splide
    document.querySelectorAll('.category-teaser-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 4,
            perMove: 1,
            focus: 0,
            trimSpace: false,
            gap: '1.25rem',
            arrows: true,
            pagination: true,
            breakpoints: {
                1200: {
                    perPage: 3,
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    arrows: false,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    gap: '0.5rem',
                    arrows: false,
                },
            },
        });

        splide.mount();
    });
});
